// extracted by mini-css-extract-plugin
export default {"scrollTop":"ScrollTop_scrollTop__tjIfS","fadeInAnimation":"ScrollTop_fadeInAnimation__tKPSH","icon":"ScrollTop_icon__ICe7T"};